<template>
  <span :style="textStyle" @click="click">{{text}}</span>
</template>
<script>
export default {
  props: {
    text: {
      type: String
    },
    color: {
      type: String
    },
    fontSize: {
      type: String
    },
    fontWeight: {
      type: String
    },
    textAlign: {
      type: String
    },
    cursor: {
      tyoe: String
    },
    marginLeft: {
      tyoe: String
    },
    marginRight: {
      tyoe: String
    },
    marginTop: {
      tyoe: String
    },
    marginBottom: {
      tyoe: String
    }
  },
  computed: {
    textStyle () {
      return {
        color: this.color,
        fontSize: this.fontSize,
        fontWeight: this.fontWeight,
        textAlign: this.textAlign,
        cursor: this.cursor,
        marginLeft: this.marginLeft,
        marginRight: this.marginRight,
        marginTop: this.marginTop,
        marginBottom: this.marginBottom

      }
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// third_party/common_app/Common/ZWSComponent/Text.vue